import React from 'react';
import { Link } from 'react-router-dom';

import PATHS from '../../../Routers/PATHS';
import { logoWordmark, logoWordmarkLight } from '../assets';

/**
 * Brand lockup for the header and footer.
 *
 * The wordmark is the exported Figma asset, 138.4×42.8, in two colourways that
 * share identical geometry: the lettering is #555555 on the white header and
 * white on the #333643 footer, while the blue mark stays the same in both.
 * Two files rather than a CSS filter, so the mark keeps its own colour.
 *
 * @param {'light'|'dark'} tone  The ground it sits on, not the mark's colour.
 * @param {string} imgClassName  The mark's size, for the sign-in card that draws it larger.
 */
const Logo = ({ tone = 'light', className = '', imgClassName = 'tw-h-[34px] tw-w-auto md:tw-h-[42.77px]' }) => (
    <Link
        to={PATHS.LANDING_HOME.URL}
        aria-label="Learning-Go Education"
        className={`tw-inline-flex tw-items-center ${className}`}
    >
        <img
            src={tone === 'dark' ? logoWordmarkLight : logoWordmark}
            alt=""
            aria-hidden
            className={imgClassName}
        />
    </Link>
);

export default Logo;
